import { style, keyframes } from '@vanilla-extract/css'

const fade = keyframes({
  '0%': { opacity: 1 },
  '15%': { opacity: 1 },
  '25%': { opacity: 0 },
  '90%': { opacity: 0 },
  '100%': { opacity: 1 },
})

const section = style({
  position: 'relative',
  aspectRatio: '880 / 1268',
  width: '100%',
})

const logo = style({
  position: 'absolute',
  width: '27.5%',
  height: '25px',
  top: '11%',
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 1,
})

const loginLink = style({
  position: 'absolute',
  top: '11%',
  right: '24px',
  zIndex: 1,
})

const image = style({
  position: 'absolute',
  willChange: 'opacity',
  animationName: fade,
  animationDuration: '12s',
  animationIterationCount: 'infinite',
  animationTimingFunction: 'ease-out',
})

const lines = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  position: 'absolute',
  left: '24px',
  bottom: '40px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
})

const heading = style({
  fontSize: '28px',
  fontWeight: '700',
  lineHeight: '1.4',
  color: 'white',
})

const text = style({
  fontSize: '15px',
  fontWeight: '700',
  lineHeight: '1.5',
  color: 'white',
})

export const styles = {
  section,
  logo,
  loginLink,
  image,
  lines,
  heading,
  text,
}
